$(document).ready(function() {
	if(!document.querySelector('.GPC0119')) return false;

	$('.GPC0119').find('.text-box-area form a').on('click', function(e) {
		e.preventDefault();
		$(this).closest('form').submit();
	});

	var els = document.querySelectorAll('.GPC0119');
	var waNumber = 0;
	$(els).each(function() {
		if($(this).find('.text-wrap .title') && !$(this).find('.text-wrap .title').is(':empty')) {
			$target = $(this).find('.text-wrap .title');
		}
		if($target) {
			$target.eq(0).attr('id', 'waGPC0119_'+waNumber);
			$(this).find('a.btn').attr('aria-describedby', 'waGPC0119_'+waNumber).attr('role', 'button');
			$(this).find('a.link-text').attr('aria-describedby', 'waGPC0119_'+waNumber);
			waNumber++;
		}
	});
});